// i18n configuration for ptc-conversions. Mirrors ptc-statetax's setup.
// Bilingual EN/ES with browser-language detection + localStorage persistence.

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import es from './locales/es.json';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'ptc-conversions-lang',
    },
    returnEmptyString: false,
  });

// <html lang> follows the UI language, so a screen reader pronounces Spanish as Spanish (fleet i18n
// standard §3). index.html can only hard-code the default.
const syncDocumentLang = (lng: string | undefined) => {
  if (typeof document !== 'undefined') document.documentElement.lang = lng?.startsWith('es') ? 'es' : 'en';
};
i18n.on('languageChanged', syncDocumentLang);
syncDocumentLang(i18n.resolvedLanguage ?? i18n.language);

export default i18n;
